import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Paper, Typography, Dialog, DialogContent, DialogTitle, Button,
} from '@material-ui/core';
import axios from 'axios';

import { NAVBAR_HEIGHT } from '../../../styles/constant';
import Counter from '../../../components/Counter';
import Loader from '../../../components/Loader';
import FormBuilder from '../../../components/FormBuilder';

class KnowledgeTestForm extends React.Component {
  static propTypes = {
    language: PropTypes.string.isRequired,
    candidateUid: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      dataLoaded: false,
      data: null,
      error: null,
      modalOpened: false,
      loading: false,
      testSubmitted: false,
      testSubmitError: false,
    };

    this.quizFormRef = null;
  }

  async componentDidMount() {
    try {
      const {
        data: { data },
      } = await axios.options(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/knowledgeTest/?language=${
          this.props.language
        }`,
      );

      this.setState({ dataLoaded: true, data });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  }

  submitQuiz = async (formData) => {
    this.setState({ loading: true });
    try {
      await axios.post(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/knowledgeTest/?language=${
          this.props.language
        }`,
        { ...formData, id: this.props.candidateUid },
      );

      this.setState({
        loading: false,
        testSubmitted: true,
        modalOpened: true,
      });
    } catch (error) {
      console.log(error); // eslint-disable-line no-console
      this.setState({
        loading: false,
        modalOpened: true,
        testSubmitted: true,
        testSubmitError: true,
      });
    }
  };

  render() {
    if (!this.state.dataLoaded) {
      return <Loader />;
    }

    if (this.state.error) {
      return <Error>{this.state.error}</Error>;
    }

    return (
      <div>
        <Navbar>
          {!this.state.testSubmitted && (
            <Counter
              minutesToCount={5}
              minutesToWarn={1}
              onCountdownFinish={() => {
                if (this.quizFormRef) {
                  const formData = this.quizFormRef.getFormData();
                  this.submitQuiz(formData);
                }
              }}
            />
          )}
        </Navbar>
        <ContentContainer>
          <FormBuilder
            ref={(comp) => {
              this.quizFormRef = comp;
            }}
            formStyle={{ paddingBottom: 80 }}
            config={this.state.data}
            renderFormActions={({ formData }) => (
              <ButtonContainer>
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.submitQuiz(formData);
                    }}
                    disabled={this.state.testSubmitted}
                  >
                    Submit
                  </Button>
                </div>
              </ButtonContainer>
            )}
          />
        </ContentContainer>

        <Dialog open={this.state.modalOpened} fullWidth>
          <DialogTitle>
            {this.state.testSubmitError ? 'Unable to Submit' : 'Successfully Submitted'}
          </DialogTitle>
          <DialogContent>
            {this.state.testSubmitError ? (
              <Typography variant="subheading">Please contact us regarding this issue.</Typography>
            ) : (
              <Typography variant="subheading">
                You have successfully submitted your test.
              </Typography>
            )}
          </DialogContent>
        </Dialog>

        {this.state.loading && <Loader />}
      </div>
    );
  }
}

export default KnowledgeTestForm;

const Error = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const Navbar = styled(Paper).attrs({
  elevation: 1,
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${NAVBAR_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 5%;
  z-index: 99;
`;

const ContentContainer = styled.div`
  position: relative;
  top: ${NAVBAR_HEIGHT}px;
  width: 90%;
  max-width: 960px;
  margin: 10px auto;
`;

const ButtonContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0px -1px 3px 0px rgba(0, 0, 0, 0.2), 0px -1px 1px 0px rgba(0, 0, 0, 0.14),
    0px -2px 1px -1px rgba(0, 0, 0, 0.12);
  z-index: 1;

  & > div {
    width: 90%;
    max-width: 960px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/KnowledgeTestQuiz/components/KnowledgeTestForm.js